module.exports = "https://static.im-cdn.com/mjc/storefront/Bright/static/media/EmptyStar.0d6e0914.svg";